// Per-device flag: "treat this device as the kitchen display".
// When true AND the app is running as an installed PWA (standalone),
// the landing redirect sends us to /display instead of /app on launch.

const KEY = "famfeel_kiosk_mode";

export const isKioskDevice = () => {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
};

export const setKioskDevice = (on) => {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {/* noop */}
};

// Standalone detection — same logic as installPwa but kept here to avoid
// a circular import.
export const isAppStandalone = () => {
  if (typeof window === "undefined") return false;
  if (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.navigator && window.navigator.standalone === true) return true;
  return false;
};

// Returns true when we should send the user straight to the display on
// app launch. Intentionally conservative: only on installed-PWA devices
// that have been explicitly marked as the kitchen display.
export const shouldAutoLaunchDisplay = () => isKioskDevice() && isAppStandalone();
